import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find} from 'lodash';
import {Table, Popup, Icon} from 'semantic-ui-react';
import {tasksStatus} from '../../../common/dictionaries/accessories';
import {Actions} from '../../../common/actions';
import TaskPauseModal from './modal/taskPause';

class TasksDetailTable extends Component {
  onStartTaskClick(taskCode) {
    const {order, technicianSelected, type} = this.props;
    const data = {
      'technician': technicianSelected,
      'nextStatus': tasksStatus.started_task,
      'action': 'start',
      'orderType': type,
    };
    this.props.addOrderTaskProgress(order, taskCode, data);
  }

  onStopTaskClick(taskCode) {
    const {order, technicianSelected, type} = this.props;
    const data = {
      'technician': technicianSelected,
      'nextStatus': tasksStatus.finished_task,
      'action': 'stop',
      'orderType': type,
    };
    this.props.addOrderTaskProgress(order, taskCode, data);
  }

  getTechnicianName(technician) {
    const {techniciansList} = this.props;
    const technicianData = find(techniciansList, {'technician': technician});
    return technicianData ?
      `${technicianData.technician} - ${technicianData.name}` :
      technician;
  }

  renderStartIcon(isRowDisabled, status, serviceCode3) {
    if (
      isRowDisabled ||
      status === tasksStatus.started_task ||
      status === tasksStatus.finished_task
    ) {
      return (
        <Icon
          name='play circle filled'
          color='gray'
          size='huge'
          className='keep-color-on-hover'
        />
      );
    }

    return (
      <Popup
        trigger={
          <Icon
            name='play circle filled'
            color='green'
            size='huge'
            className='keep-color-on-hover pointer'
            onClick={() => this.onStartTaskClick(serviceCode3)}
          />
        }
        content='Iniciar Tarea'
        position='top center'
        inverted
      />
    );
  }

  renderStopIcon(isRowDisabled, status, serviceCode3) {
    if (isRowDisabled || status !== tasksStatus.started_task) {
      return (
        <Icon
          name='stop circle'
          color='gray'
          size='huge'
          className='keep-color-on-hover'
        />
      );
    }

    return (
      <Popup
        trigger={
          <Icon
            name='stop circle'
            color='red'
            size='huge'
            className='keep-color-on-hover pointer'
            onClick={() => this.onStopTaskClick(serviceCode3)}
          />
        }
        content='Finalizar Tarea'
        position='top center'
        inverted
      />
    );
  }

  renderItems() {
    const {technicianSelected, order, tasks, type} = this.props;
    if (!tasks || !tasks.length) {
      return (
        <Table.Row textAlign='center'>
          <Table.Cell colSpan={5}>La orden no tiene tareas</Table.Cell>
        </Table.Row>
      );
    }

    return tasks.map((task, index) => {
      const isRowDisabled = technicianSelected !== task.technician;
      return (
        <Table.Row key={index} textAlign='center' disabled={isRowDisabled}>
          <Table.Cell>{task.serviceCode3}</Table.Cell>
          <Table.Cell>{task.description}</Table.Cell>
          <Table.Cell>{this.getTechnicianName(task.technician)}</Table.Cell>
          <Table.Cell>{task.localFlat}</Table.Cell>
          <Table.Cell className='action-column'>
            {this.renderStartIcon(
              isRowDisabled,
              task.status,
              task.serviceCode3
            )}
            <TaskPauseModal
              order={order}
              serviceCode3={task.serviceCode3}
              technicianSelected={technicianSelected}
              isRowDisabled={isRowDisabled}
              status={task.status}
              type={type}
            />
            {this.renderStopIcon(isRowDisabled, task.status, task.serviceCode3)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <Table striped className='tasks-detail-table'>
        <Table.Header>
          <Table.Row textAlign='center'>
            <Table.HeaderCell className='task-code-column'>
              Código Tarea
            </Table.HeaderCell>
            <Table.HeaderCell className='task-desc-column'>
              Descripción
            </Table.HeaderCell>
            <Table.HeaderCell className='technician-column'>
              Técnico
            </Table.HeaderCell>
            <Table.HeaderCell className='time-column'>
              Tiempo Estimado
            </Table.HeaderCell>
            <Table.HeaderCell className='actions-column'>
              Acciones
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>{this.renderItems()}</Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'techniciansList': state.techniciansAssignment.list,
    'loading': state.timeMarked.loadingTasks,
    'tasks': state.timeMarked.tasks,
  };
};

const {addOrderTaskProgress} = Actions;

export default connect(mapStateToProps, {
  addOrderTaskProgress,
})(TasksDetailTable);
